/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

/**
 * This is the Picture component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */

const Picture = forwardRef(
  ({ className, sources, img, onLoad, onError, ...props }, ref) => {
    if (sources && sources.length) {
      return (
        <picture className={className}>
          {sources.map((source, index) => (
            <source key={index} {...source} />
          ))}
          <img
            ref={ref}
            alt=""
            {...props}
            {...img}
            onLoad={onLoad}
            onError={onError}
          />
        </picture>
      );
    }

    return (
      <img
        ref={ref}
        className={className}
        alt=""
        {...props}
        {...img}
        onLoad={onLoad}
        onError={onError}
      />
    );
  }
);

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Picture.propTypes = {
  className: PropTypes.string,
  sources: PropTypes.array.isRequired,
  img: PropTypes.object.isRequired,
  onLoad: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Picture.defaultProps = {
  sources: [],
  img: {},
  onLoad: () => {},
  onError: () => {},
};

export default Picture;
